import { AxiosPromise } from "axios";
import { axios } from "../axios";
import { IDateRange, IApiList } from "../../app/types";
import {
  IOrder,
  EOrderStatus,
  IOrdersListFilters,
} from "./types";
import { getPagination, getSortFilter } from "../../app/utils";
//import mock from './mock.json';

const getStatusFilter = (statuses: EOrderStatus[]) => {
  if (statuses.length === 0) {
    return "";
  }
  let query = "";
  statuses.forEach((status) => {
    query = `${query}&statuses=${status}`;
  });
  return query;
};

const getDatesFilter = (dates: IDateRange) => {
  let query = "";
  if (dates.start) {
    query = `&fromDate=${dates.start.toISOString()}`;
  }
  if (dates.end) {
    query = `${query}&toDate=${dates.end.toISOString()}`;
  }
  return query;
};

export const getOrders = (
  siteId: number,
  filters: IOrdersListFilters
): AxiosPromise<IApiList<IOrder>> => {
  //return Promise.resolve({ data: mock.list } as unknown as AxiosPromise);
  const {
    page,
    pageSize,
    statusFilter,
    dateFilter,
    dateFilterSort,
  } = filters;
  return axios.get(
    `/orders?siteId=${siteId}&${getPagination(page, pageSize)}${getStatusFilter(
      statusFilter
    )}${getDatesFilter(dateFilter)}${getSortFilter(
      dateFilterSort
    )}`
  );
};

export const getOrder = (orderId: string): AxiosPromise<IOrder> => {
  //return Promise.resolve({ data: mock.order } as unknown as AxiosPromise);
  return axios.get(`/orders/${orderId}?withProductSummary=1`);
};

export const changeOrderProductReturnedQuantity = (orderId: string, productId: number, returnedQuantity: number): AxiosPromise<IOrder> => {
  //return Promise.resolve({ data: mock.order } as unknown as AxiosPromise);
  return axios.put(`/orders/${orderId}/products/${productId}`, { returnedQuantity: returnedQuantity });
};

export const exportToCSV = (
  siteId: number,
  filters: IOrdersListFilters
): AxiosPromise<string> => {
  const { statusFilter, dateFilter, dateFilterSort } = filters;
  return axios.get(
    `/orders/report?siteId=${siteId}${getPagination(-1, -1)}${getStatusFilter(statusFilter)}${getDatesFilter(dateFilter)}${getSortFilter(dateFilterSort)}`
  );
};

export const updateOrderStatus = (orderId: string, status: EOrderStatus): AxiosPromise<IOrder> => {
  return axios.put(`/orders/${orderId}`, { status: status });
};

export const processRefunds = (orderId: string): AxiosPromise<IOrder> => {
  return axios.post(`/orders/${orderId}/process-refunds`);
};
